export const slovakRegions: string[] = [
    'Bratislavský',
    'Trnavský',
    'Trenčiansky',
    'Nitriansky',
    'Žilinský',
    'Banskobystrický',
    'Prešovský',
    'Košický'
]
